import { isEmpty } from './object-utils';
import { getFormattedIntegerValues } from './number-utils';

const dateFormatOptions = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
};

const dateSmallFormatOptions = {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: 'numeric'
};

const timeFormatOptions = {
    hour: 'numeric', minute: 'numeric', second: 'numeric'
};

export function getNowDate() {
    return new Date();
}

export function getFormattedNowDate() {
    const dateTimeFormat = new Intl.DateTimeFormat('en-GB', dateFormatOptions);
    return dateTimeFormat.format(getNowDate());
}

export function getFormattedDate(dateToFormat) {
    const dateTimeFormat = new Intl.DateTimeFormat('en-GB', dateFormatOptions);
    return dateTimeFormat.format(dateToFormat);
}

export function getSmallFormattedDate(dateToFormat) {
    const dateTimeFormat = new Intl.DateTimeFormat('en-GB', dateSmallFormatOptions);
    return dateTimeFormat.format(dateToFormat);
}

export function getFormattedTime(dateToFormat) {
    const dateTimeFormat = new Intl.DateTimeFormat('en-GB', timeFormatOptions);
    return dateTimeFormat.format(dateToFormat);
}

export function getFormattedSeconds(valueInSeconds) {

    if (isNaN(valueInSeconds)) {
        valueInSeconds = 0;
    }

    const day = getFormattedIntegerValues(valueInSeconds / (24 * 3600));
    valueInSeconds %= (24 * 3600);
    const hour = getFormattedIntegerValues(valueInSeconds / 3600);

    valueInSeconds %= 3600;
    const minutes = getFormattedIntegerValues(valueInSeconds / 60);

    valueInSeconds %= 60;
    const seconds = getFormattedIntegerValues(valueInSeconds);

    return `${day} day(s) ${hour}:${minutes}:${seconds}`;
}

export function getDateAsISOString(dateToChange) {
    if (isEmpty(dateToChange)) {
        return dateToChange;
    }

    const simpleDate = new Date(dateToChange);
    const utcDate = new Date(Date.UTC(simpleDate.getFullYear(), simpleDate.getMonth(), simpleDate.getDate()));
    return utcDate.toISOString();
}


export function areDatesEqual(firstDate, secondDate) {
    return firstDate.getTime() === secondDate.getTime();
}

export function compareDates(firstDate, secondDate) {
    if (firstDate.getTime() === secondDate.getTime()) {
        return 0;
    }

    if (firstDate.getTime() > secondDate.getTime()) {
        return 1;
    }

    return -1;
}
